module.exports = __webpack_public_path__ + "static/media/iconpen.2e47bae7.svg";